import {
    createApi,
    fakeBaseQuery,
} from '@reduxjs/toolkit/query';
import { getQueryParam } from '@vfde-sails/utils';
import {
    AbstractedHardwareDetailGroupResponse,
    AbstractedTariffWithHardwareResponse,
    GladosEndpointVersion,
    GladosServiceFactory,
    HardwareDetailGroupParamsV1,
    TariffWithHardwareParamsV1,
} from '@vfde-sails/glados-v2';
import { IInitialState } from 'Container/App/interface';
import {
    API_BTX_MULTICARD,
    API_SALESCHANNEL_CONSUMER,
    STONE_VIRTUAL_ID,
} from '@vfde-sails/constants';
import { AxiosError } from 'axios';

const gladosApi = createApi({
    reducerPath: 'GladosService',
    baseQuery: fakeBaseQuery(),
    endpoints: build => ({
        getDeviceDetailGroup: build.query<
            AbstractedHardwareDetailGroupResponse,
            IInitialState['customerConfig']['deviceId']
        >({
            queryFn: async deviceId => {
                const hardwareService = GladosServiceFactory.getHardwareService();



                const params: HardwareDetailGroupParamsV1 = {
                    btx: API_BTX_MULTICARD,
                    salesChannel: [API_SALESCHANNEL_CONSUMER],
                    groupId: deviceId!,
                    discountIds: [],
                    tariffIds: [STONE_VIRTUAL_ID],
                };

                try {
                    const response = await hardwareService.getHardwareDetailGroup(GladosEndpointVersion.V1, params);



                    return { data: response.data };
                }
                catch (error) {
                    if (error instanceof AxiosError) {
                        return {
                            error: {
                                status: error.status,
                                message: error.message,
                            },
                        };
                    }

                    return {
                        error: {
                            message: (error as Error).message,
                        },
                    };
                }
            },
        }),
        getTariffWithHardware: build.query<AbstractedTariffWithHardwareResponse, string[]>({
            queryFn: async atomicIds => {
                const tariffService = GladosServiceFactory.getTariffService();



                const params: TariffWithHardwareParamsV1 = {
                    btx: API_BTX_MULTICARD,
                    salesChannel: [API_SALESCHANNEL_CONSUMER],
                    discountIds: [],
                    tariffIds: [STONE_VIRTUAL_ID],
                    atomicIds,
                };

                try {
                    const response = await tariffService.getTariffWithHardware(GladosEndpointVersion.V1, params);



                    return { data: response.data };
                }
                catch (error) {
                    if (error instanceof AxiosError) {
                        return {
                            error: {
                                status: error.status,
                                message: error.message,
                            },
                        };
                    }

                    return {
                        error: {
                            message: (error as Error).message,
                        },
                    };
                }
            },
        }),
    }),
});

export default gladosApi;

export const {
    getDeviceDetailGroup,
    getTariffWithHardware,
} = gladosApi.endpoints;
